import React from 'react';
import PropTypes from 'prop-types';
import {withI18n} from 'react-i18next';

const valueIfNull = (value) => {
    if (value) {
        return value;
    } else {
        return <br />
    }
}

const ResourceTextPropertyView = ({t, label, value}) => (
    <div className="lara-text-wrapper">
        <span className='lara-text-label'>{t(label)}:</span>
        <span className='lara-text-value'>{valueIfNull(value)}</span>
    </div>
)

ResourceTextPropertyView.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.any
};


export default withI18n()(ResourceTextPropertyView);